import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../config/axios';
import './PaymentCallback.css';

const PaymentCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const resultCode = searchParams.get('resultCode');
        const orderId = searchParams.get('orderId');
        const message = searchParams.get('message');

        console.log('Payment callback params:', { resultCode, orderId, message });

        if (resultCode === '0') {
          setStatus('success');
          setMessage('Đang xác nhận thanh toán...');
          
          try {
            const response = await api.get(`/api/payment/momo/status/${orderId}`);
            
            if (response.data.data.status === 'paid') {
              setMessage('Thanh toán thành công! Đơn hàng của bạn đã được xử lý.');
            } else {
              setMessage('Thanh toán đang được xử lý. Vui lòng chờ...');
            }
          } catch (error) {
            console.error('Error checking payment status:', error);
            setMessage('Thanh toán thành công! Đơn hàng của bạn đã được xử lý.');
          }
          
          setTimeout(() => {
            navigate('/orders/payment');
          }, 3000);
        } else {
          setStatus('error');
          setMessage(message || 'Thanh toán thất bại. Vui lòng thử lại.');
          
          setTimeout(() => {
            navigate('/orders/payment');
          }, 5000);
        }
      } catch (error) {
        console.error('Payment callback error:', error);
        setStatus('error');
        setMessage('Có lỗi xảy ra. Vui lòng thử lại.');
        
        setTimeout(() => {
          navigate('/orders/payment');
        }, 5000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="payment-callback">
      <div className="payment-callback-container">
        <div className={`payment-callback-icon ${status}`}>
          {status === 'loading' && <div className="loading-spinner"></div>}
          {status === 'success' && <span>✓</span>}
          {status === 'error' && <span>✗</span>}
        </div>
        
        <h2 className="payment-callback-title">
          {status === 'loading' && 'Đang xử lý...'}
          {status === 'success' && 'Thanh toán thành công!'}
          {status === 'error' && 'Thanh toán thất bại'}
        </h2>
        
        <p className="payment-callback-message">{message}</p>
        
        <button 
          className="payment-callback-btn"
          onClick={() => navigate('/orders/payment')}
        >
          Quay lại trang thanh toán
        </button>
      </div>
    </div>
  );
};

export default PaymentCallback; 